import { dataExport } from 'ducks/entities/schema'

export const dataExportsApiV0ResponseSchema = [dataExport]

export const dataExportApiV0ResponseSchema = dataExport
